import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core'
import { Field } from '@dot-it/jml-lib'
import { Observable, Subject } from 'rxjs'

@Component({
  selector: 'jml-lib-fields-view',
  templateUrl: './fields-view.component.html',
  styleUrls: ['./fields-view.component.scss']
})
export class FieldsViewComponent implements OnInit {
  @ViewChild('table', { read: ElementRef, static: false }) tableRef: ElementRef
  @Input() fields: Field[]
  @Input() refreshTrigger: Subject<[string, number]>
  @Input() rowData: object
  @Input() dtoType: string
  @Output() DEPRECATED_finishCellEdit: EventEmitter<any> = new EventEmitter()
  @Output() finishCellEdit: EventEmitter<any> = new EventEmitter()

  ngOnInit() {}

  afterTableInit() {
    this.tableRef?.nativeElement.addEventListener(
      'click',
      (event: MouseEvent) => {
        if (event.target['id'] === 'cancelRowSelection') {
          // If the target indicates a cancellation of a row selection event, stop its propagation to prevent row selection
          event.preventDefault()
          event.stopPropagation()
          document.dispatchEvent(new MouseEvent('click'))
          // dispatch new event to target
          event.target.dispatchEvent(new CustomEvent('edit'))
        }
      },
      true
    )
  }

  // currently, data is of structure: {data: rowData, field: changedFieldName}
  completeCellEdit(data: any) {
    this.DEPRECATED_finishCellEdit.emit(data)
  }

  updateField(field: string, value: any) {
    this.finishCellEdit.emit({ field, value })
  }

  _isCatalogueEntry(field: Field): boolean {
    return Field.isCatalogueEntry(field)
  }

  _isEntityReference(field: Field): boolean {
    return Field.isEntityReference(field)
  }
}
